import { render, staticRenderFns } from "./input-product-limit.vue?vue&type=template&id=5479e4f1&"
import script from "./input-product-limit.vue?vue&type=script&lang=js&"
export * from "./input-product-limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports